import { ADMIN_SIDEBAR } from "../../actionTypes/types";

export const isTruthy = (value) => value === true || value === "true";

// Keep browser-route access and sidebar visibility on the same feature policy.
// `onlyLmsEnabled` is meaningful only when LMS itself is enabled; treating an
// inconsistent payload as a normal EC Card organisation prevents redirect
// loops where neither the core portal nor LMS has an available landing page.
export const getAdminCapabilities = (orgDetails = {}) => {
  const lms = isTruthy(orgDetails.lmsEnabled);
  const onlyLms = lms && isTruthy(orgDetails.onlyLmsEnabled);

  return {
    core: !onlyLms,
    lms,
    physicalCard: !onlyLms && isTruthy(orgDetails.isPhysicalCardEnabled),
  };
};

export const getAdminDefaultPath = (orgDetails = {}) =>
  getAdminCapabilities(orgDetails).core
    ? "/admin/manage-users"
    : "/admin/lms/overview";

export const isAdminCapabilityEnabled = (orgDetails, capability) => {
  if (!capability) return true;
  return getAdminCapabilities(orgDetails)[capability] === true;
};

export const getVisibleAdminSidebar = (
  orgDetails,
  sidebar = ADMIN_SIDEBAR
) => {
  if (!orgDetails) return [];

  const featureFlags = getAdminCapabilities(orgDetails);
  const featureOnlyMenuGates = ["lms"];
  const onlyLmsEnabled = !featureFlags.core;

  const isFeatureEnabled = (featureGate) => {
    if (!featureGate) return true;
    if (Object.prototype.hasOwnProperty.call(featureFlags, featureGate)) {
      return featureFlags[featureGate];
    }
    return true;
  };

  return (sidebar || [])
    .flatMap((item) => {
      if (onlyLmsEnabled) {
        if (item.featureGate) {
          if (!featureOnlyMenuGates.includes(item.featureGate)) return [];
          if (!isFeatureEnabled(item.featureGate)) return [];
          if (!item.subMenu) return [item];
          const filteredSub = item.subMenu.filter((subItem) =>
            isFeatureEnabled(subItem.featureGate)
          );
          return [{ ...item, subMenu: filteredSub }];
        }

        return (item.subMenu || []).filter(
          (subItem) =>
            subItem.featureGate &&
            featureOnlyMenuGates.includes(subItem.featureGate)
        );
      }

      if (!isFeatureEnabled(item.featureGate)) return [];
      if (!item.subMenu) return [item];
      const filteredSub = item.subMenu.filter((subItem) =>
        isFeatureEnabled(subItem.featureGate)
      );
      if (filteredSub.length === 0) return [];
      return [{ ...item, subMenu: filteredSub }];
    })
    .filter(Boolean);
};
